import { render, staticRenderFns } from "./UnitSchema.vue?vue&type=template&id=b0d9eaca"
import script from "./UnitSchema.vue?vue&type=script&lang=js"
export * from "./UnitSchema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports